<style scoped lang="scss">

</style>

<template>
  <div>
    <Head title="Businesses" />
    <h1 class="mb-8 text-3xl font-bold">My Businesses</h1>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <card-component
        title=""
        has-button-slot>
        <div class="has-text-centered notification is-dark-passive" v-if="businesses.length === 0">
          <p>No businesses assigned to user.</p>
        </div>
        <b-table :data="businesses" v-else>

          <b-table-column label="Name" v-slot="props">
            {{ props.row.name }}
          </b-table-column>

          <b-table-column label="Website" v-slot="props">
            <span v-if="props.row.domain">
              <div>
                <a :href="'https://'+props.row.domain.name" target="_blank">
                  {{ props.row.domain.name }}
                  <i class="fa fa-link"></i>
                </a>
              </div>
              <div>
                <b-tag type="is-warning" rounded>Performance 58</b-tag>
                <b-tag type="is-success" rounded>Accessibility 100</b-tag>
                <b-tag type="is-danger" rounded>Best Practices 20</b-tag>
                <b-tag type="is-warning" rounded>SEO 87</b-tag>
              </div>
            </span>
          </b-table-column>

          <b-table-column numeric v-slot="props">
<!--              <b-tooltip-->
<!--                type="is-dark"-->
<!--                position="is-left"-->
<!--                :label="props.row.id === sectorTarget.current_customer_id ? 'Current Customer for Sector Target' : 'Make Current Customer'">-->
<!--                <Link class="button"-->
<!--                      method="post"-->
<!--                      :disabled="props.row.id === sectorTarget.current_customer_id"-->
<!--                      :class="{'is-primary': props.row.id === sectorTarget.current_customer_id}" :href="`/sector-targets/${sectorTarget.id}/set-customer/${props.row.id}`">-->
<!--                  <i class="fa fa-usd"></i>-->
<!--                </Link>-->
<!--              </b-tooltip>-->
<!--              <Link class="button is-primary" :href="`/sector-targets/${sectorTarget.id}/businesses/${props.row.id}/edit`">-->
<!--                <i class="fa fa-edit"></i>-->
<!--              </Link>-->

<!--              <Link class="button is-danger" @click="deleteBusiness(props.row)">-->
<!--                <i class="fa fa-trash"></i>-->
<!--              </Link>-->
          </b-table-column>
        </b-table>
      </card-component>
<!--      <table class="w-full whitespace-nowrap">-->
<!--        <tr v-for="business in businesses" :key="business.id" class="hover:bg-gray-100 focus-within:bg-gray-100">-->
<!--          <td class="border-t">-->
<!--            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/businesses/${business.id}`">-->
<!--              {{ business.name }}-->
<!--            </Link>-->
<!--          </td>-->
<!--        <tr v-if="businesses.total === 0">-->
<!--          <td class="px-6 py-4 border-t" colspan="4">No businesses fool! Go make sum</td>-->
<!--        </tr>-->
<!--      </table>-->
    </div>
  </div>
</template>

<script>
import customerLayout from '@/Shared/CustomerLayout.vue'
import CardComponent from '@/Shared/CardComponent.vue'

export default {
  components: {CardComponent},
  props: {
    businesses: Object,
  },
  layout: customerLayout
}
</script>
